<!-- eslint-disable max-len -->
<style scoped>
  .special-instructions-card-body {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .special-instructions-card-header {
    background-color: #D5D5D5;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    margin-bottom:0;
    padding-top: 0.75rem;
    padding-right: 1.25rem;
    padding-bottom: 0.75rem;
    padding-left: 1.25rem;
  }
  .workorder-card-body {
    padding: 0 !important;
  }
  .workorder-tabs {
    min-height: 480px;
  }
  .work-order-bill-approval-button {
    margin-top: 1px;
    margin-left: 7px;
    border: 0;
    padding-top: 8px;
    padding-right: 16px;
    padding-bottom: 8px;
    padding-left: 16px;
  }
  .btn.disabled, .btn:disabled {
    background-color: #888888;
    color: black;
    opacity: 0.50;
    pointer-events: none;
  }
</style>
<template>
  <div id="project-workorders" class='view-contents'>
    <b-alert :show="showErrorMessageAlert" dismissible variant="danger">
      <div>{{showErrorMessageAlertBody}}</div>
    </b-alert>
    <div v-if='config'>
      <b-modal id="workorderInvalidLineItemsModal">
        <template v-slot:modal-title>
          <span class='project-modal-warning'>Line Items are Required!</span>
        </template>
        <p>You must add at least one Line Item to this Work Order before it can be submitted.</p>
        <template v-slot:modal-footer="{ ok }">
          <b-button size="sm" variant="success" @click="ok" class='btn-success'>Ok</b-button>
        </template>
      </b-modal>
      <b-modal id="workorderInvalidLineItemsTotalsModal">
        <template v-slot:modal-title>
          <span class='project-modal-warning'>Line Item Totals Exceed Budget!</span>
        </template>
        <p>There is at least one Line Item on this Work Order that exceeds the budget.</p>
        <template v-slot:modal-footer="{ ok }">
          <b-button size="sm" variant="success" @click="ok" class='btn-success'>Ok</b-button>
        </template>
      </b-modal>
      <b-modal id="workorderSubmitForReviewModal" @ok="workorderSubmitForReviewOnClickOk()">
        <template v-slot:modal-title>
          <span class='project-modal-warning'>Confirm Work Order Submittal</span>
        </template>
        <p>Are you sure you want to set this Work Order&apos;s status to &quot;Review&quot;?</p>
        <template v-slot:modal-footer="{ ok, cancel }">
          <b-button size="sm" variant="danger" @click="cancel" class='btn-danger'>No</b-button>
          <b-button size="sm" variant="success" @click="ok" class='btn-success'>Yes</b-button>
        </template>
      </b-modal>
      <b-modal id="workorderSubmitToVendorModal" @ok="workorderSubmitToVendorOnClickOk()">
        <template v-slot:modal-title>
          <span class='project-modal-warning'>Confirm Work Order Submittal</span>
        </template>
        <p>Are you sure you want to set this Work Order&apos;s status to &quot;Submitted&quot;?</p>
        <template v-slot:modal-footer="{ ok, cancel }">
          <b-button size="sm" variant="danger" @click="cancel" class='btn-danger'>No</b-button>
          <b-button size="sm" variant="success" @click="ok" class='btn-success'>Yes</b-button>
        </template>
      </b-modal>
      <b-modal id="workorderAcceptedByVendorModal" @ok="workorderAcceptedByVendorOnClickOk()">
        <template v-slot:modal-title>
          <span class='project-modal-warning'>Confirm Work Order Submittal</span>
        </template>
        <p>Are you sure you want to set this Work Order&apos;s status to &quot;Accepted&quot;?</p>
        <template v-slot:modal-footer="{ ok, cancel }">
          <b-button size="sm" variant="danger" @click="cancel" class='btn-danger'>No</b-button>
          <b-button size="sm" variant="success" @click="ok" class='btn-success'>Yes</b-button>
        </template>
      </b-modal>
      <b-modal id="workorderCompleteModal" @ok="workorderCompleteOnClickOk()">
        <template v-slot:modal-title>
          <span class='project-modal-warning'>Confirm Work Order Submittal</span>
        </template>
        <p>Are you sure you want to set this Work Order&apos;s status to &quot;Completed&quot;?</p>
        <template v-slot:modal-footer="{ ok, cancel }">
          <b-button size="sm" variant="danger" @click="cancel" class='btn-danger'>No</b-button>
          <b-button size="sm" variant="success" @click="ok" class='btn-success'>Yes</b-button>
        </template>
      </b-modal>
      <b-modal id="workorderCancelModal" @ok="workorderCancelOnClickOk()">
        <template v-slot:modal-title>
          <span class='project-modal-warning'>Confirm Work Order Submittal</span>
        </template>
        <p>Are you sure you want to set this Work Order&apos;s status to &quot;Cancelled&quot;?</p>
        <template v-slot:modal-footer="{ ok, cancel }">
          <b-button size="sm" variant="danger" @click="cancel" class='btn-danger'>No</b-button>
          <b-button size="sm" variant="success" @click="ok" class='btn-success'>Yes</b-button>
        </template>
      </b-modal>
      <b-modal id="workorderLineItemDeleteModal" title="Confirm Delete" @ok="onWorkOrderLineItemDeleteOkClick()">
        <div>Are you sure you want to delete this Line Item?</div>
        <template v-slot:modal-footer="{ ok, cancel }">
          <b-button size="sm" variant="danger" @click="cancel" class='incentive-payments-dialog-no'>No</b-button>
          <b-button size="sm" variant="success" @click="ok" class='incentive-payments-dialog-yes'>Yes</b-button>
        </template>
      </b-modal>
    </div>
    <b-modal id="projectWorkOrderBillAddModal" title="Add Bill" size="xl">
      <div class='container p-3' v-if='projectWorkOrderBillModel'>
        <div class='row'>
          <div class='col-3'>Work Order Total: {{ projectWorkOrderBillModel.workOrderTotal | toCurrency }}</div>
          <div class='col-3'>Other Bills Total: {{ projectWorkOrderBillModel.otherBillsTotal | toCurrency }}</div>
          <div class='col-3'>This Bill Total: {{ getBillPaymentTotal(projectWorkOrderBillModel) | toCurrency | toCurrency }}</div>
          <div class='col-3'>Billable Remaining: {{ projectWorkOrderBillableRemaining | toCurrency }}</div>
        </div>
      </div>
      <VueFormGenerator :schema="projectWorkOrderBillSchema" :model="projectWorkOrderBillModel" :options="formOptions"  @validated="onProjectWorkOrderBillValidated"/>
      <b-table
        v-if='projectWorkOrderBillModel && projectWorkOrderBillModel.workOrderBillLineItems && projectWorkOrderBillModel.workOrderBillLineItems.length > 0'
        :fields="projectWorkOrderBillLineItemFieldsAdd"
        :items="projectWorkOrderBillModel.workOrderBillLineItems"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        bordered
        hover
        responsive
        small
        striped
      >
        <template v-slot:cell(salePrice)="row">
          <input type='number' v-model="row.item.salePrice" class='form-control align-top' @input='restrictSalePrice(row.item, $event)'/>
        </template>
        <template v-slot:cell(quantity)="row">
          <input type='number' v-model="row.item.quantity" class='form-control align-top' step="0.01" @input='restrictQuantity(row.item, $event)'/>
        </template>
        <template v-slot:cell(itemCost)="row">
          {{(row.item.salePrice * row.item.quantity) | toCurrency}}
        </template>
      </b-table>
      <b-table
        v-if='projectWorkOrderBillModel && projectWorkOrderBillModel.workOrderBillIncentivePayments && projectWorkOrderBillModel.workOrderBillIncentivePayments.length > 0'
        :fields="projectWorkOrderBillIncentivePaymentFieldsAdd"
        :items="projectWorkOrderBillModel.workOrderBillIncentivePayments"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        bordered
        hover
        responsive
        small
        striped
      >
        <template v-slot:cell(billSelected)="row">
          <b-form-checkbox v-model="row.item.billSelected"
            @input="validateProjectWorkOrderBillRequiredFields([])"
          />
        </template>
      </b-table>
      <hr class='project-workorder-bills-header-horizontal-rule project-workorder-bills-horizontal-rule'/>
      <div v-if='projectWorkOrderBillModel' class='project-workorder-bills-items-details-label'>
        <span class='details-label'>Total Payment: </span>
        <span>{{getBillPaymentTotal(projectWorkOrderBillModel) | toCurrency}}</span>
      </div>
      <template v-slot:modal-footer>
        <b-button size="sm" variant="danger" @click="onProjectWorkOrderBillAddCancelClick" class='incentive-payments-dialog-no'>Cancel</b-button>
        <b-button :disabled="(projectWorkOrderBillModelValid === false) || validateBillableRemainingIsNotOverTwentyPercent() || !validateBillDateIsPriorToReceivedDate()"
          size="sm" variant="success" @click="onProjectWorkOrderBillAddOkClick" class='incentive-payments-dialog-yes'>
          <span>Save</span>
        </b-button>
      </template>
    </b-modal>
    <b-modal id="projectWorkOrderBillEditModal" title="Edit Bill" size="xl">
      <div class='container p-3' v-if='projectWorkOrderBillModel'>
        <div class='row'>
          <div class='col-3'>Work Order Total: {{ projectWorkOrderBillModel.workOrderTotal | toCurrency }}</div>
          <div class='col-3'>Other Bills Total: {{ projectWorkOrderBillModel.otherBillsTotal | toCurrency }}</div>
          <div class='col-3'>This Bill Total: {{ getBillPaymentTotal(projectWorkOrderBillModel) | toCurrency | toCurrency }}</div>
          <div class='col-3'>Billable Remaining: {{ projectWorkOrderBillableRemaining | toCurrency }}</div>
        </div>
      </div>
      <VueFormGenerator :schema="projectWorkOrderBillSchema" :model="projectWorkOrderBillModel" :options="formOptions"  @validated="onProjectWorkOrderBillValidated"/>
      <hr class='project-workorder-bills-header-horizontal-rule project-workorder-bills-horizontal-rule'/>
      <div class='details-label project-workorder-bills-items-details-label'>Costs For</div>
      <b-table
        v-if='projectWorkOrderBillModel && projectWorkOrderBillModel.workOrderBillLineItems && projectWorkOrderBillModel.workOrderBillLineItems.length > 0'
        :fields="projectWorkOrderBillLineItemFieldsEdit"
        :items="projectWorkOrderBillModel.workOrderBillLineItems"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        bordered
        hover
        responsive
        small
        striped
      >
        <template v-slot:cell(salePrice)="row">
          <input type='number' v-model="row.item.salePrice" class='form-control align-top' @input='restrictSalePrice(row.item, $event)'/>
        </template>
        <template v-slot:cell(quantity)="row">
          <span class='align-top'>
            <input type='number' v-model="row.item.quantity" class='form-control align-top' step="0.01" @input='restrictQuantity(row.item, $event)'/>
          </span>
        </template>
        <template v-slot:cell(itemCost)="row">
          {{(row.item.salePrice * row.item.quantity) | toCurrency}}
        </template>
      </b-table>
      <b-table
        v-if='projectWorkOrderBillModel && projectWorkOrderBillModel.workOrderBillIncentivePayments && projectWorkOrderBillModel.workOrderBillIncentivePayments.length > 0'
        :fields="projectWorkOrderBillIncentivePaymentFieldsEdit"
        :items="projectWorkOrderBillModel.workOrderBillIncentivePayments"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        bordered
        hover
        responsive
        small
        striped
      >
        <template v-slot:cell(billSelected)="">
          {{true}}
        </template>
      </b-table>
      <hr class='project-workorder-bills-header-horizontal-rule project-workorder-bills-horizontal-rule'/>
      <div v-if='projectWorkOrderBillModel' class='project-workorder-bills-items-details-label'>
        <span class='details-label'>Total Payment: </span>
        <span>{{getBillPaymentTotal(projectWorkOrderBillModel) | toCurrency}}</span>
      </div>
      <template v-slot:modal-footer>
        <b-button size="sm" variant="danger" @click="onProjectWorkOrderBillEditCancelClick" class='incentive-payments-dialog-no'>Cancel</b-button>
        <b-button :disabled="(projectWorkOrderBillModelValid === false) || validateBillableRemainingIsNotOverTwentyPercent()" size="sm" variant="success" @click="onProjectWorkOrderBillEditOkClick" class='incentive-payments-dialog-yes'>
          <span>Save</span>
        </b-button>
      </template>
    </b-modal>
    <b-modal id="submitBillForApprovalModal" title="Confirm Submit Bill for Approval" @ok="onBillSubmitForApprovalClickOk()">
      <div>
        <p>You are about to submit this Bill to the Planner. You will not be able to edit the Bill once submitted.</p>
        <p>Are you sure you want to submit?</p>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="cancel" class='incentive-payments-dialog-no'>No</b-button>
        <b-button size="sm" variant="success" @click="ok" class='incentive-payments-dialog-yes'>Yes</b-button>
      </template>
    </b-modal>
    <b-modal id="submitBillForPaymentModal" title="Confirm Submit Bill for Payment" @ok="onBillSubmitForPaymentClickOk()">
      <div>
        <p>You are acknowledging that the Bill as entered has been reviewed by you, is correct, and is ready for Finance to approve.</p>
        <p>Are you sure you want to submit?</p>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="cancel" class='incentive-payments-dialog-no'>No</b-button>
        <b-button size="sm" variant="success" @click="ok" class='incentive-payments-dialog-yes'>Yes</b-button>
      </template>
    </b-modal>
    <b-modal id="voidBillModal" title="Confirm Bill Void" @ok="onBillVoidClickOk()">
      <div>
        <p>You are about to void this Bill. It will no longer be editable by you or any other user.</p>
        <p>Are you sure you want to void?</p>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="cancel" class='incentive-payments-dialog-no'>No</b-button>
        <b-button size="sm" variant="success" @click="ok" class='incentive-payments-dialog-yes'>Yes</b-button>
      </template>
    </b-modal>
    <b-modal id="approveBillModal" title="Confirm Bill Approval" @ok="onBillApproveClickOk()">
      <div>
        <p>You are acknowledging that the Bill as entered has been reviewed by you, is correct, and is ready for payment.</p>
        <p>Are you sure you want to approve?</p>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="cancel" class='incentive-payments-dialog-no'>No</b-button>
        <b-button size="sm" variant="success" @click="ok" class='incentive-payments-dialog-yes'>Yes</b-button>
      </template>
    </b-modal>
    <b-modal id="paidBillModal" title="Confirm Bill Paid" @ok="onBillPaidClickOk()">
      <div>
        <p>You are about to flag this Bill as 'Paid'. It will no longer be editable by you or any other user.</p>
        <p>Are you sure you want to flag it as 'Paid'?</p>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="cancel" class='incentive-payments-dialog-no'>No</b-button>
        <b-button size="sm" variant="success" @click="ok" class='incentive-payments-dialog-yes'>Yes</b-button>
      </template>
    </b-modal>
    <div class="section-title">Work Orders</div>
    <b-overlay :show="formLoading" class='workorder-tabs'>
      <b-tabs v-if='!formLoading && projectWorkorders && projectWorkorders.length > 0' v-model='projectWorkOrderTabIndex' pills vertical>
        <b-tab v-for='projectWorkorder in projectWorkorders' :key='projectWorkorder.id' :title="'Work Order ' + projectWorkorder.workOrderNumber">
          <template #title-active>
            <span>Work Order {{projectWorkorder.workOrderNumber}}&nbsp;&nbsp;</span>
            <b-icon-arrow-right-circle-fill class='h3' variant='primary'/>
          </template>
          <div class='card card-body'>
            <b-alert
              v-if='!formLoading'
              :show="!isWorkOrderFundingComplete(projectWorkorder)"
              dismissible
              variant="danger"
            >
              <div>This Work Order has Line Items with no Funding Source specified.</div>
              <div>Bills can only be added to this Work Order when all Line Item Funding Sources have been specified.</div>
            </b-alert>
            <div class='card-body workorder-card-body'>
              <b-row class='details-row'>
                <b-col cols="3" class="details-label">
                  <span>Work Order:</span>
                </b-col>
                <b-col cols="4">
                  <a :href='`${config.insightly.workOrderUrl}${projectWorkorder.id}`' target='insightly'>
                    <span>{{projectWorkorder.workOrderNumber}}</span>
                    <span>&nbsp;|&nbsp;</span>
                    <span>{{projectWorkorder.workOrderName}}</span>
                  </a>
                  <b-link v-if='(!workorderLookupsLoading) && (projectWorkorder.status !== "Completed") && (projectWorkorder.status !== "Cancelled")' @click='onWorkorderEditClick(projectWorkorder)' v-b-tooltip.hover title='Edit this Work Order'>
                    <span class='project-workorder-edit'></span>
                  </b-link>
                </b-col>
                <b-col v-if='formLoaded' cols="5" class='text-right'>
                  <span
                    v-if='isWorkOrderCancelMember && isWorkorderCancelVisible(projectWorkorder)'
                    v-b-tooltip.hover='{ disabled: !isWorkorderCancelDisabled(projectWorkorder) }'
                    :title='isWorkorderCancelDisabledTitle(projectWorkorder)'
                  >
                    <b-button
                      :disabled='isWorkorderCancelDisabled(projectWorkorder)'
                      class="rounded-pill work-order-bill-approval-button"
                      variant='danger'
                      @click='workorderCancelOnClick(projectWorkorder)'
                    >
                      <span>Cancel</span>
                    </b-button>
                  </span>
                  <b-button
                    v-if='isWorkOrderSubmitForReviewMember && isWorkorderSubmitForReviewVisible(projectWorkorder)'
                    class="rounded-pill work-order-bill-approval-button"
                    variant='primary'
                    title='Submit for Review'
                    @click='workorderSubmitForReviewOnClick(projectWorkorder)'
                  >
                    <span>Submit for Review</span>
                  </b-button>
                  <b-button
                    v-if='isWorkOrderSubmitToVendorMember && isWorkorderSubmitToVendorVisible(projectWorkorder) && !isJuniorPlanner'
                    class="rounded-pill work-order-bill-approval-button"
                    variant='primary'
                    title='Submit to Vendor'
                    @click='workorderSubmitToVendorOnClick(projectWorkorder, projectWorkorders, projectWorkorderLineItemFundingSources, projectBudgetYearSnapshots, fundingSources)'
                  >
                    <span>Submit to Vendor</span>
                  </b-button>
                  <b-button
                    v-if='isWorkOrderAcceptedByVendorMember && isWorkorderAcceptedByVendorVisible(projectWorkorder)'
                    class="rounded-pill work-order-bill-approval-button"
                    variant='primary'
                    title='Accepted by Vendor'
                    @click='workorderAcceptedByVendorOnClick(projectWorkorder, projectWorkorders, projectWorkorderLineItemFundingSources, projectBudgetYearSnapshots, fundingSources)'
                  >
                    <span>Accepted by Vendor</span>
                  </b-button>
                  <span
                    v-if='isWorkOrderCompleteMember && isWorkorderCompleteVisible(projectWorkorder)'
                    v-b-tooltip.hover='{ disabled: !isWorkorderCompleteDisabled(projectWorkorder) }'
                    :title='isWorkorderCompleteDisabledTitle(projectWorkorder)'
                  >
                    <b-button
                      :disabled='isWorkorderCompleteDisabled(projectWorkorder)'
                      class="rounded-pill work-order-bill-approval-button"
                      variant='primary'
                      @click='workorderCompleteOnClick(projectWorkorder)'
                    >
                      <span>Complete</span>
                    </b-button>
                  </span>
                </b-col>
                <b-col v-else>
                  <LoadingSpinner v-if='!formLoaded' message='Loading Bill Data' size='1x'/>
                </b-col>
              </b-row>
              <b-row class='details-row'>
                <b-col cols="3" class="details-label">Status:</b-col>
                <b-col>{{projectWorkorder.status}}</b-col>
              </b-row>
              <b-row class='details-row'>
                <b-col cols="3" class="details-label">Date Updated:</b-col>
                <b-col>{{new Date(projectWorkorder.dateUpdatedUTC).toLocaleString()}}</b-col>
              </b-row>
              <b-row class='details-row'>
                <b-col cols="3" class="details-label">Vendor:</b-col>
                <b-col>
                  <span v-if='projectWorkorder.vendorContactId != null'>{{getVendorContactName(projectWorkorder)}}</span>
                  <span v-else>
                    <span v-if='projectWorkorder.vendorOrganizationId != null'>{{getVendorOrganizationName(projectWorkorder)}}</span>
                  </span>
                </b-col>
              </b-row>
              <b-row class='details-row'>
                <b-col cols="3" class="details-label">Requested Completion Date:</b-col>
                <b-col>{{(new Date(projectWorkorder.requestedDate)).toLocaleDateString()}}</b-col>
              </b-row>
              <b-row class='details-row'>
                <b-col cols="3" class="details-label">Grand Total:</b-col>
                <!-- <b-col>{{projectWorkorder.grandTotal | toCurrency}}</b-col> -->
                <b-col>{{getGrandTotal(projectWorkorder) | toCurrency}}</b-col>
              </b-row>
              <b-row class='details-row'>
                <b-col cols="3" class="details-label">District or Partner Total:</b-col>
                <b-col>{{getDistrictOrPartnerTotal(projectWorkorder) | toCurrency}}</b-col>
              </b-row>
              <b-row class='details-row'>
                <b-col cols="3" class="details-label">Approved for Payment:</b-col>
                <b-col>{{getApprovedForPaymentTotal(projectWorkorder) | toCurrency}}</b-col>
              </b-row>
              <b-row class='details-row'>
                <b-col cols="3" class="details-label">Pending Bill Approval:</b-col>
                <b-col>{{getPendingBillApprovalTotal(projectWorkorder) | toCurrency}}</b-col>
              </b-row>
              <b-row class='details-row'>
                <b-col cols="3" class="details-label">Spent:</b-col>
                <b-col>{{getSpentTotal(projectWorkorder) | toCurrency}}</b-col>
              </b-row>
              <b-row class='details-row'>
                <b-col cols="3" class="details-label">Remaining:</b-col>
                <b-col>{{getRemainingTotal(projectWorkorder) | toCurrency}}</b-col>
              </b-row>
            </div>
            <div class='card-body special-instructions-card-body'>
              <div class='special-instructions-card-header'>
                <span class='details-label'>Special Instructions</span>
                <a v-b-toggle="`workorder-${projectWorkorder.id}-card`" class="c-pointer">
                  <b-icon icon='caret-right-fill' class="when-closed" />
                  <b-icon icon='caret-down-fill' class="when-opened" />
                </a>
              </div>
              <b-collapse :id="`workorder-${projectWorkorder.id}-card`" class='card' visible>
                <b-form-textarea class='project-workorder-special-instructions' v-model='projectWorkorder.contractorSpecialInstructions' readonly rows='4'/>
              </b-collapse>
            </div>
            <div class='card section-header'>
              <div class='special-instructions-card-header'>
                <span class='details-label'>Services and Materials</span>
                <span
                  class='d-inline-block add-link'
                  v-b-tooltip.hover='{ disabled: !isLineItemAddDisabled(projectWorkorder) }'
                  title="Line Items can't be added to 'Completed' Work Orders."
                >
                  <b-link
                    v-if='(projectBudget && projectBudget.projectBudgetYears) && !workorderLookupsLoading'
                    class="add-link"
                    @click='onWorkorderLineItemAddClick(projectWorkorder)'
                    v-b-tooltip.hover title='Add a new Line Item to this Work Order'
                    :disabled='isLineItemAddDisabled(projectWorkorder)'
                  >
                    <b-icon icon="plus"></b-icon>
                    <span>Add Line Item</span>
                  </b-link>
                </span>
              </div>
              <div v-if='!projectWorkorder.workOrderLineItems || projectWorkorder.workOrderLineItems.length === 0' class='card-body'>Edit to add unplanned items.</div>
              <div v-else class='card-body'>
                <div v-if='!workOrderLineItemEditing'>
                  <b-table
                    :ref='`workOrderLineItemsTable${projectWorkorder.id}`'
                    :fields="getProjectWorkOrderLineItemFields(projectWorkorder)"
                    :items="projectWorkorder.workOrderLineItems"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    bordered
                    hover
                    small
                    striped
                  >
                    <template v-slot:cell(totalPrice)="row">
                      {{(row.item.salePrice * row.item.quantity) | toCurrency}}
                    </template>

                    <template v-slot:cell(districtPartnerPercent)="row">
                      {{(getDistrictAndPartnerPercent(row.item)) | toPercent}}
                    </template>

                    <template v-slot:cell(districtPartnerCost)="row">
                      {{(getDistrictAndPartnerCost(row.item)) | toCurrency}}
                    </template>

                    <template v-slot:cell(costBilledToDate)="row">
                      {{(row.item.salePrice * row.item.quantityBilledToDate) | toCurrency}}
                    </template>
                    <template v-slot:cell(billingComplete)="row">
                      <b-form-checkbox
                        v-if='projectWorkorder.status === "Accepted"'
                        v-model="row.item.billingComplete"
                        @change="onWorkOrderLineItemBillingCompleteChanged($event, projectWorkorder, row.item)"
                        :disabled='(workOrderLineItemBillingCompleteSaving || errorMessage !== null)'
                      />
                      <span v-else>{{row.item.billingComplete}}</span>
                    </template>
                    <template v-slot:cell(actions)="row">
                      <b-row>
                        <b-col>
                          <b-link v-if='(projectBudget && projectBudget.projectBudgetYears) && !workorderLookupsLoading' @click='onWorkOrderLineItemEditClick(row.item)' v-b-tooltip.hover title='Edit this Line Item' :disabled='isLineItemAddDisabled(projectWorkorder)'>
                            <div class='project-workorder-lineitem-edit'></div>
                          </b-link>
                        </b-col>
                        <b-col>
                          <b-link v-b-modal="'workorderLineItemDeleteModal'" @click='onWorkOrderLineItemDeleteClick(row.item)' v-b-tooltip.hover title='Delete this Line Item' :disabled='isLineItemAddDisabled(projectWorkorder)'>
                            <div class='project-workorder-lineitem-delete'></div>
                          </b-link>
                        </b-col>
                      </b-row>
                    </template>
                  </b-table>
              </div>
              </div>
            </div>
            <div class='card section-header'>
              <div class='special-instructions-card-header'>
                <span class='details-label'>Incentive Payments</span>
                <span
                  class='d-inline-block add-link'
                  v-b-tooltip.hover='{ disabled: !isIncentivePaymentAddDisabled(projectWorkorder) }'
                  title="Incentive Payments can't be added to 'Completed' Work Orders."
                >
                  <b-link
                    v-if='(projectBudget && projectBudget.projectBudgetYears) && !workorderLookupsLoading'
                    class="add-link"
                    @click='onWorkorderIncentivePaymentAddClick(projectWorkorder)'
                    v-b-tooltip.hover title='Add a new Incentive Payment to this Work Order'
                    :disabled='isIncentivePaymentAddDisabled(projectWorkorder)'
                  >
                    <b-icon icon="plus"></b-icon>
                    <span>Add Incentive Payment</span>
                  </b-link>
                </span>
              </div>
              <div v-if='!projectWorkorder.workOrderProjectIncentives || projectWorkorder.workOrderProjectIncentives.length === 0' class='card-body'>No incentive payments.</div>
              <div v-else class='card-body'>
                <div v-if='!workOrderIncentivePaymentEditing'>
                  <b-table
                    :ref='`workOrderIncentivePaymentsTable${projectWorkorder.id}`'
                    :fields="getProjectWorkOrderIncentivePaymentFields()"
                    :items="getIncentiveItems(projectWorkorder.workOrderProjectIncentives)"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    bordered
                    hover
                    small
                    striped
                  >
                    <template v-slot:cell(incentiveType)="row">
                      {{row.item.incentiveType}}
                    </template>
                    <template v-slot:cell(paymentAmount)="row">
                      {{(row.item.paymentAmount) | toCurrency}}
                    </template>
                    <template v-slot:cell(fundingSource)="row">
                      {{row.item.fundingSource}}
                    </template>
                    <template v-slot:cell(incentiveBillingComplete)="row">
                      <span>{{row.item.incentiveBillingComplete}}</span>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
            <div v-if='isBillViewer' class="card section-header">
              <div class="special-instructions-card-header">
                <span class='details-label'>Bills</span>
                <span
                  v-if='isBillAddVisible()'
                  class='d-inline-block add-link'
                  v-b-tooltip.hover='{ disabled: !isBillAddDisabled(projectWorkorder) }'
                  :title='isBillAddDisabled(projectWorkorder) && "Work Order must be in Accepted status with outstanding Line Items to Add Bills"'
                >
                  <b-link
                    :disabled='isBillAddDisabled(projectWorkorder)'
                    @click='onProjectWorkOrderBillAddClick(projectWorkorder.id)'
                  >
                    <b-icon icon="plus"></b-icon>
                    <span>Add Bill</span>
                  </b-link>
                </span>
              </div>
              <LoadingSpinner v-if='!formLoaded' message='Loading Bill Data' size='1x'/>
              <div v-else>
                <div v-if='projectWorkorder.workOrderBills != null && projectWorkorder.workOrderBills.length > 0' class='card-body'>
                  <div v-for='bill in projectWorkorder.workOrderBills' :key='bill.id' class='project-workorder-bills-card-body'>
                    <div class='special-instructions-card-header'>
                      <b-row>
                        <b-col cols="2">
                        <span class='details-label'>Invoice #{{bill.billIdentifier}}</span>
                        <a v-b-toggle="`bill-${bill.id}-card`" class="c-pointer">
                          <b-icon icon='caret-right-fill' class="when-closed" />
                          <b-icon icon='caret-down-fill' class="when-opened" />
                        </a>
                        </b-col>
                        <b-col cols="6">
                          <span class='details-label'>Invoice ID:</span>
                          <span>{{bill.billUniqueIdentifier}}</span>
                        </b-col>
                        <b-col cols="3" >
                          <span class='details-label'>Total Payment:</span>
                          <span>{{getBillPaymentTotal(bill) | toCurrency}}</span>
                        </b-col>
                        <b-col cols="1" class='text-right'>
                          <b-link
                            v-if="isBillEditVisible(bill)"
                            @click='onProjectWorkOrderBillEditClick(bill.workOrderId, bill.id)'
                            class="project-workorder-edit"
                          />
                        </b-col>
                      </b-row>
                    </div>
                    <b-collapse
                      v-if='bill.id == billId'
                      :id="`bill-${bill.id}-card`"
                      :ref="`bill-${bill.id}-card`"
                      class='card card-body'
                      visible
                    >
                      <b-row class='details-row'>
                        <b-col cols="2" class="details-label">Status:</b-col>
                        <b-col cols="4">{{bill.status}}</b-col>
                        <b-col cols="2" class="details-label">Entered By:</b-col>
                        <b-col cols="4">{{bill.createdByName}}</b-col>
                      </b-row>
                      <b-row class='details-row'>
                        <b-col cols="2" class="details-label">Invoiced:</b-col>
                        <b-col cols="4">{{(new Date(bill.billDate)).toLocaleDateString()}}</b-col>
                        <b-col cols="2" class="details-label">Received:</b-col>
                        <b-col cols="4">{{(new Date(bill.receivedDate)).toLocaleDateString()}}</b-col>
                      </b-row>
                      <hr class='project-workorder-bills-horizontal-rule project-workorder-bills-notes-horizontal-rule'/>
                      <b-row class='details-row'>
                        <b-col cols="3" class="details-label">Notes:</b-col>
                        <b-col>{{bill.notes}}</b-col>
                      </b-row>
                      <b-table
                        v-if='bill.workOrderBillLineItems'
                        :fields="projectWorkOrderBillLineItemFields"
                        :items="bill.workOrderBillLineItems"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        bordered
                        hover
                        small
                        striped
                      />
                      <b-table
                        v-if='bill.workOrderBillIncentivePayments'
                        :fields="projectWorkOrderBillIncentivePaymentFields"
                        :items="bill.workOrderBillIncentivePayments"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        bordered
                        hover
                        small
                        striped
                        >
                        <template v-slot:cell(incentiveType)="row">
                          {{getIncentiveType(bill, row.item)}}
                        </template>
                        <template v-slot:cell(amountBilled)="row">
                          {{(row.item.amountBilled) | toCurrency}}
                        </template>
                      </b-table>
                      <b-row>
                        <div class='col-12 text-right'>
                          <b-button
                            v-if='isBillVoidVisible(bill)'
                            class="rounded-pill work-order-bill-approval-button"
                            variant='danger'
                            title='Void Bill'
                            @click="onBillVoidClick(bill)"
                          >
                            <span>Void Bill</span>
                          </b-button>
                          <b-button
                            v-if='isBillSubmitForApprovalVisible(bill)'
                            class="rounded-pill work-order-bill-approval-button"
                            variant='primary'
                            title='Submit for Approval'
                            @click="onBillSubmitForApprovalClick(bill)"
                          >
                            <span>Submit for Approval</span>
                          </b-button>
                          <b-button
                            v-if='isBillSubmitForPaymentVisible(bill)'
                            class="rounded-pill work-order-bill-approval-button"
                            variant='primary'
                            title='Submit for Payment'
                            @click="onBillSubmitForPaymentClick(bill)"
                          >
                            <span>Submit for Payment</span>
                          </b-button>
                          <b-button
                            v-if='isBillApproveVisible(bill)'
                            class="rounded-pill work-order-bill-approval-button"
                            variant='primary'
                            title='Approve'
                            @click="onBillApproveClick(bill)"
                          >
                            <span>Approve</span>
                          </b-button>
                          <b-button
                            v-if='isBillPaidVisible(bill)'
                            class="rounded-pill work-order-bill-approval-button"
                            variant='primary'
                            title='Paid'
                            @click="onBillPaidClick(bill)"
                          >
                            <span>Paid</span>
                          </b-button>
                        </div>
                      </b-row>
                    </b-collapse>
                    <b-collapse
                      v-else
                      :id="`bill-${bill.id}-card`"
                      class='card card-body'
                      :visible='getBillVisible(bill)'
                    >
                      <b-row class='details-row'>
                        <b-col cols="2" class="details-label">Status:</b-col>
                        <b-col cols="4">{{bill.status}}</b-col>
                        <b-col cols="2" class="details-label">Entered By:</b-col>
                        <b-col cols="4">{{bill.createdByName}}</b-col>
                      </b-row>
                      <b-row class='details-row'>
                        <b-col cols="2" class="details-label">Invoiced:</b-col>
                        <b-col cols="4">{{(new Date(bill.billDate)).toLocaleDateString()}}</b-col>
                        <b-col cols="2" class="details-label">Received:</b-col>
                        <b-col cols="4">{{(new Date(bill.receivedDate)).toLocaleDateString()}}</b-col>
                      </b-row>
                      <hr class='project-workorder-bills-horizontal-rule project-workorder-bills-notes-horizontal-rule'/>
                      <b-row class='details-row'>
                        <b-col cols="3" class="details-label">Notes:</b-col>
                        <b-col>{{bill.notes}}</b-col>
                      </b-row>
                      <b-table
                        v-if='bill.workOrderBillLineItems'
                        :fields="projectWorkOrderBillLineItemFields"
                        :items="bill.workOrderBillLineItems"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        bordered
                        hover
                        small
                        striped
                      />
                      <b-table
                        v-if='bill.workOrderBillIncentivePayments'
                        :fields="projectWorkOrderBillIncentivePaymentFields"
                        :items="bill.workOrderBillIncentivePayments"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        bordered
                        hover
                        small
                        striped
                      >
                        <template v-slot:cell(incentiveType)="row">
                          {{getIncentiveType(bill, row.item)}}
                        </template>
                        <template v-slot:cell(amountBilled)="row">
                          {{(row.item.amountBilled) | toCurrency}}
                        </template>
                      </b-table>
                      <b-row>
                        <div class='col-12 text-right'>
                          <b-button
                            v-if='isBillVoidVisible(bill)'
                            class="rounded-pill work-order-bill-approval-button"
                            variant='danger'
                            title='Void Bill'
                            @click="onBillVoidClick(bill)"
                          >
                            <span>Void Bill</span>
                          </b-button>
                          <b-button
                            v-if='isBillSubmitForApprovalVisible(bill)'
                            class="rounded-pill work-order-bill-approval-button"
                            variant='primary'
                            title='Submit for Approval'
                            @click="onBillSubmitForApprovalClick(bill)"
                          >
                            <span>Submit for Approval</span>
                          </b-button>
                          <b-button
                            v-if='isBillSubmitForPaymentVisible(bill)'
                            class="rounded-pill work-order-bill-approval-button"
                            variant='primary'
                            title='Submit for Payment'
                            @click="onBillSubmitForPaymentClick(bill)"
                          >
                            <span>Submit for Payment</span>
                          </b-button>
                          <b-button
                            v-if='isBillApproveVisible(bill)'
                            class="rounded-pill work-order-bill-approval-button"
                            variant='primary'
                            title='Approve'
                            @click="onBillApproveClick(bill)"
                          >
                            <span>Approve</span>
                          </b-button>
                          <b-button
                            v-if='isBillPaidVisible(bill)'
                            class="rounded-pill work-order-bill-approval-button"
                            variant='primary'
                            title='Paid'
                            @click="onBillPaidClick(bill)"
                          >
                            <span>Paid</span>
                          </b-button>
                        </div>
                      </b-row>
                    </b-collapse>
                  </div>
                </div>
                <div v-else class='card-body'>
                  No Bills have been added to this Work Order.
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
      <b-tabs v-if='projectWorkorders && projectWorkorders.length === 0'>
        <div class='card-body'>No Work Orders have been added to this project.</div>
      </b-tabs>
    </b-overlay>
    <ProjectWorkorderEdit v-if='projectWorkorderEditIsVisible' @saved='load()' />
    <ProjectWorkorderLineItemAdd v-if='projectWorkorderLineItemAddIsVisible' />
    <ProjectWorkorderIncentivePaymentAdd v-if='projectWorkorderIncentivePaymentAddIsVisible' />
    <ProjectWorkorderLineItemEdit v-if='projectWorkorderLineItemEditIsVisible' />
  </div>
</template>
<script>
/* eslint-disable max-len, padded-blocks */
import { mapState } from 'vuex';
import FiscalYear from '@/mixins/fiscalYear';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';
import ProjectBudgetHelperExpenditureSummary from '@/mixins/projectBudgetHelperExpenditureSummary';
import ProjectSchemaHelper from '@/mixins/projectSchemaHelper';
import ProjectWorkOrderApprovalManager from '@/mixins/projectWorkOrderApprovalManager';
import ProjectWorkOrderBillingApprovalManager from '@/mixins/projectWorkOrderBillingApprovalManager';
import ProjectWorkOrderBillingLineItemManager from '@/mixins/projectWorkOrderBillingLineItemManager';
import ProjectWorkOrderBillingManager from '@/mixins/projectWorkOrderBillingManager';
import ProjectWorkOrderBillingMembershipManager from '@/mixins/projectWorkOrderBillingMembershipManager';
import ProjectWorkOrderLineItemManager from '@/mixins/projectWorkOrderLineItemManager';
import ProjectWorkorderEdit from '@/components/projects/ProjectWorkorderEdit.vue';
import ProjectWorkorderLineItemAdd from '@/components/projects/ProjectWorkorderLineItemAdd.vue';
import ProjectWorkorderIncentivePaymentAdd from '@/components/projects/ProjectWorkorderIncentivePaymentAdd.vue';
import ProjectWorkorderLineItemEdit from '@/components/projects/ProjectWorkorderLineItemEdit.vue';
import ProjectWorkOrderManager from '@/mixins/projectWorkOrderManager';

export default {
  name: 'ProjectWorkOrders',
  components: {
    LoadingSpinner,
    ProjectWorkorderEdit,
    ProjectWorkorderLineItemAdd,
    ProjectWorkorderIncentivePaymentAdd,
    ProjectWorkorderLineItemEdit,
  },
  mixins: [
    FiscalYear,
    ProjectBudgetHelperExpenditureSummary,
    ProjectSchemaHelper,
    ProjectWorkOrderApprovalManager,
    ProjectWorkOrderBillingApprovalManager,
    ProjectWorkOrderBillingLineItemManager,
    ProjectWorkOrderBillingManager,
    ProjectWorkOrderBillingMembershipManager,
    ProjectWorkOrderLineItemManager,
    ProjectWorkOrderManager,
  ],
  computed: {
    ...mapState(['config']),
    ...mapState('Contact', {
      contactBriefs: (e) => e.contactBriefs,
    }),
    ...mapState('Membership', {
      memberOf: (e) => e.memberOf,
    }),
    ...mapState('Opportunity', {
      opportunityBriefs: (e) => e.workorderOpportunityBriefs,
    }),
    ...mapState('Organization', {
      organizationBriefs: (e) => e.organizationBriefs,
    }),
    ...mapState('Pricelist', {
      pricelistEntries: (e) => e.pricelistEntries,
    }),
    ...mapState('Project', {
      fundingSources: (e) => e.fundingSources,
      fundsPerFiscalYear: (e) => e.fundsPerFiscalYear.funds,
      products: (state) => state.products,
      project: (state) => state.project,
      projectBudget: (state) => state.projectBudget,
      projectBudgetYearSnapshots: (state) => state.projectBudgetYearSnapshots,
      projectWorkorders: (e) => e.projectWorkorders,
      projectWorkorderBill: (e) => e.projectWorkorderBill,
      projectWorkorderBills: (e) => e.projectWorkorderBills,
      projectWorkorderLineItemFundingSources: (e) => e.projectWorkorderLineItemFundingSources,
      projectIncentivePayments: (e) => e.projectIncentivePayments,
    }),
    ...mapState('Workorder', {
      errorMessage: (e) => e.errorMessage,
      formLoading: (e) => e.formLoading,
      projectWorkorder: (e) => e.workorder,
      projectWorkorderLineItemAddedModel: (e) => e.workorderLineItemAddedModel,
      workorderIncentivePaymentAddedModel: (e) => e.workorderIncentivePaymentAddedModel,
      workorderIncentivePaymentBillingCompleteModel: (e) => e.workorderIncentivePaymentBillingCompleteModel,
    }),
  },
  data() {
    return {
      billId: 0,
      formOptions: { validateAfterChanged: true },
      formSchema: {},
      formLoaded: false,
      formValid: false,
      lineItemFundingSourceList: [],
      projectWorkorderEditIsVisible: false,
      projectWorkorderLineItemAddIsVisible: false,
      projectWorkorderIncentivePaymentAddIsVisible: false,
      projectWorkorderLineItemEditIsVisible: false,
      projectWorkOrderTabIndex: 0,
      showErrorMessageAlert: false,
      showErrorMessageAlertBody: '',
      unsubscribeSetWorkorderLineItemAddedModel: null,
      unsubscribeSetWorkorderIncentivePaymentAddedModel: null,
      unsubscribeSetWorkorderLineItemEditedModel: null,
      workOrderLineItemBillingCompleteSaving: false,
      workOrderLineItemEditing: false,
      workOrderIncentivePaymentEditing: false,
      workOrderIncentivePaymentsCompleteSaving: false,
    };
  },
  async mounted() {
    await this.load();

    if (this.unsubscribeSetWorkorderLineItemAddedModel === null) {
      this.unsubscribeSetWorkorderLineItemAddedModel = this.$store.subscribe(async (mutation) => {
        if (mutation.type === 'Workorder/SET_WORKORDER_LINEITEM_ADDED_MODEL') {
          this.workOrderLineItemEditing = true;
          const lineItem = mutation.payload;
          await this.$store.dispatch('Workorder/getWorkorder', lineItem.workOrderId);
          if (this.projectWorkorderBills) {
            this.projectWorkorder.workOrderBills = this.projectWorkorderBills.filter((e) => e.workOrderId === this.projectWorkorder.id);
          }
          this.setProjectWorkorderLineItemCalculatedValues([this.projectWorkorder]);
          this.$store.dispatch('Project/replaceProjectWorkorder', this.projectWorkorder);
          await this.loadProjectWorkorderLineItemFundingSources();
          this.workOrderLineItemEditing = false;
        }
      });
    }

    if (this.unsubscribeSetWorkorderLineItemEditedModel === null) {
      this.unsubscribeSetWorkorderLineItemEditedModel = this.$store.subscribe(async (mutation) => {
        if (mutation.type === 'Workorder/SET_WORKORDER_LINEITEM_EDITED_MODEL') {
          this.workOrderLineItemEditing = true;
          const lineItem = mutation.payload;
          await this.$store.dispatch('Workorder/getWorkorder', lineItem.workOrderId);
          if (this.projectWorkorderBills) {
            this.projectWorkorder.workOrderBills = this.projectWorkorderBills.filter((e) => e.workOrderId === this.projectWorkorder.id);
          }
          this.setProjectWorkorderLineItemCalculatedValues([this.projectWorkorder]);
          this.$store.dispatch('Project/replaceProjectWorkorder', this.projectWorkorder);
          await this.loadProjectWorkorderLineItemFundingSources();
          this.workOrderLineItemEditing = false;
        }
      });
    }

    if (this.unsubscribeSetWorkorderIncentivePaymentAddedModel === null) {
      this.unsubscribeSetWorkorderIncentivePaymentAddedModel = this.$store.subscribe(async (mutation) => {
        if (mutation.type === 'Workorder/SET_WORKORDER_INCENTIVEPAYMENT_ADDED_MODEL') {
          this.workOrderIncentivePaymentEditing = true;
          const lineItem = mutation.payload;
          await this.$store.dispatch('Workorder/getWorkorder', lineItem.workOrderId);
          if (this.projectWorkorderBills) {
            this.projectWorkorder.workOrderBills = this.projectWorkorderBills.filter((e) => e.workOrderId === this.projectWorkorder.id);
          }
          this.setProjectWorkorderLineItemCalculatedValues([this.projectWorkorder]);
          this.$store.dispatch('Project/replaceProjectWorkorder', this.projectWorkorder);
          this.workOrderIncentivePaymentEditing = false;
        }
      });
    }
  },
  async updated() {
    if (this.billId !== 0) {
      const billCardRefArray = this.$refs[`bill-${this.billId}-card`];
      if (billCardRefArray && billCardRefArray.length > 0) {
        billCardRefArray[0].$el.scrollIntoView(true);
      }
    }
  },
  methods: {
    load() {
      (async () => {
        this.formLoaded = false;
        try {
          await this.$store.dispatch('Workorder/setFormLoading', true);

          await this.$store.dispatch('Project/getProjectBudgetYearSnapshots', parseInt(this.$route.params.id, 10));

          await this.$store.dispatch('Project/getProjectWorkorders', parseInt(this.$route.params.id, 10));

          if (this.$route.params.workorderId && this.$route.params.workorderId != null) {
            await this.$store.dispatch('Workorder/getWorkorder', this.$route.params.workorderId);
            const workorderId = parseInt(this.$route.params.workorderId, 10);
            if (this.projectWorkorders.length > 0) {
              const workorderIndex = this.projectWorkorders.findIndex((e) => e.id === workorderId);
              if (workorderIndex >= 0) this.projectWorkOrderTabIndex = workorderIndex;
              if (this.$route.params.billId && this.$route.params.billId != null) {
                this.billId = parseInt(this.$route.params.billId, 10);
              }
            }
          }

          await this.$store.dispatch('Project/fetchProducts');
          await this.$store.dispatch('Project/getProjectIncentivePayments', parseInt(this.$route.params.id, 10));

          await this.loadProjectWorkorderLineItemFundingSources();
          await this.loadProjectWorkorderBills();
          await this.loadWorkorderLookups();

          this.setProjectWorkorderLineItemCalculatedValues(this.projectWorkorders);

          await this.$store.dispatch('Workorder/setFormLoading', false);
        } catch (error) {
          // Check if it's a 500 error
          if (error.response && error.response.status === 500) {
            console.error('Server error (500):', error);
            // Show error to user
            this.showErrorMessageAlert = true;
            this.showErrorMessageAlertBody = 'Server error occurred while loading project work orders.';
          } else {
            // Handle other errors
            console.error('Error loading data:', error);
            this.showErrorMessageAlert = true;
            this.showErrorMessageAlertBody = 'An error occurred while loading data.';
          }
        }
        this.formLoaded = true;
      })();
    },
    getIncentiveItems(workOrderProjectIncentives) {
      const incentiveItems = workOrderProjectIncentives.map((e) => {
        const incentive = this.projectIncentivePayments.filter((i) => i.id === e.projectIncentivePaymentId)[0];
        const incentiveFundingSource = this.fundingSources.find(
          (fundingSource) => fundingSource.recorD_ID === incentive?.fundingSourceId,
        );
        const incentiveBillingComplete = incentive?.datePaid !== null;
        return {
          id: e.id,
          paymentAmount: e.paymentAmount,
          paymentDate: e.paymentDate,
          projectIncentivePaymentId: e.projectIncentivePaymentId,
          fundingSourceId: incentive?.fundingSourceId,
          /* eslint-disable camelcase */
          fundingSource: incentiveFundingSource?.recorD_NAME,
          incentiveTypeId: incentive?.incentiveTypeId,
          incentiveType: incentive?.incentiveType.name,
          incentiveBillingComplete,
        };
      });
      return incentiveItems;
    },
    getIncentiveType(bill, item) {
      const workOrder = this.projectWorkorders.find((wo) => wo.id === bill.workOrderId);
      const workOrderIncentive = workOrder.workOrderProjectIncentives.find((woi) => woi.id === item.workOrderIncentivePaymentId);
      const projectIncentive = this.projectIncentivePayments.find((pi) => pi.id === workOrderIncentive.projectIncentivePaymentId);
      return projectIncentive.incentiveType.name;
    },
  },
};
</script>
